<div>
    Not found 404

    <a [routerLink]="['/']">Home</a>
</div>